import { useAppSelector } from "@/Hook/hooks";
import { ControlTranslation } from "AlignComponents";
import { Card } from "react-bootstrap";
import { FaTasks } from "react-icons/fa";
import { LuCalendarMinus } from "react-icons/lu";

const MyTasks = () => {
  const myTask = useAppSelector(x => x.Home.SelfService.myTask);

  return (
    <div className="widget my-tasks">
      <Card>
        <Card.Header>
          <Card.Title>
            <FaTasks size={18} className="icon" />
            <ControlTranslation system={true} controlId="lblmytasks" />
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <div className="tasks">
            {
              myTask.map(x => (
                <div className="task">
                  <div className="text">
                    <h6>
                      {x.taskstxt}
                    </h6>
                    <span>
                      {x.tasksubject}
                    </span>
                    <div className="badge bg-info fs-8">
                      {x.duedate}
                    </div>
                  </div>
                  <div className="ms-auto">
                    <div className="badge bg-outline-primary">
                      {x.taskstatushdr}
                    </div>
                  </div>
                </div>
              ))
            }
          </div>
        </Card.Body>
      </Card>
    </div >
  )
};

export default MyTasks;